<template>
    <div class="property-panel">
        <div v-if="selectedNode" class="panel-content">
            <h3>节点属性</h3>
            <div class="property-section">
                <div class="form-group">
                    <label>节点ID</label>
                    <input :value="selectedNode.id" type="text" class="form-control" readonly />
                </div>
                <div class="form-group">
                    <label>节点名称</label>
                    <input v-model="nodeForm.name" type="text" class="form-control" />
                </div>
                <div class="form-group">
                    <label>节点描述</label>
                    <textarea v-model="nodeForm.desc" class="form-control" rows="3"></textarea>
                </div>
                <div class="form-group">
                    <label>节点图片URL(待实现)</label>
                    <input v-model="nodeForm.imageUrl" type="text" class="form-control" />
                </div>
                <div class="panel-actions">
                    <button @click="saveNode" class="btn btn-primary">保存</button>
                    <button @click="saveNodePosition" class="btn btn-secondary">保存位置(待实现)</button>
                    <button @click="lockNode" class="btn btn-warning">锁定(待实现)</button>
                    <button @click="highlightNode" class="btn btn-info">高亮(待实现)</button>
                    <button @click="deleteNode" class="btn btn-danger">删除(待实现)</button>
                </div>

                <div class="form-group">
                    <label>节点分组</label>
                    <div class="groups-container">
                        <div v-for="group in groups" :key="group.id" class="group-item"
                            :class="{ 'group-selected': isGroupSelected(group.id) }" @click="toggleGroup(group.id)">
                            {{ group.name }}
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label>节点位置</label>
                    <div class="position-inputs">
                        <input v-model.number="nodeForm.x" type="number" placeholder="X" class="form-control" />
                        <input v-model.number="nodeForm.y" type="number" placeholder="Y" class="form-control" />
                    </div>
                </div>
                <div class="form-group">
                    <label>节点大小(待实现)</label>
                    <input v-model.number="nodeForm.symbolSize" type="number" class="form-control" />
                </div>
                <div class="form-group checkbox-group">
                    <label>
                        <input v-model="nodeForm.locked" type="checkbox" /> 锁定节点(待实现)
                    </label>
                </div>
            </div>

        </div>

        <div v-else-if="selectedEdge" class="panel-content">
            <h3>连接属性</h3>
            <div class="property-section">
                <div class="form-group">
                    <label>连接ID</label>
                    <input :value="selectedEdge.id" type="text" class="form-control" readonly />
                </div>
                <div class="form-group">
                    <label>源节点(待实现)</label>
                    <input :value="getNodeLabel(selectedEdge.source)" type="text" class="form-control" readonly />
                </div>
                <div class="form-group">
                    <label>目标节点(待实现)</label>
                    <input :value="getNodeLabel(selectedEdge.target)" type="text" class="form-control" readonly />
                </div>
                <div class="form-group">
                    <label>连接标签(待实现)</label>
                    <input v-model="edgeForm.label" type="text" class="form-control" />
                </div>
                <div class="form-group">
                    <label>连接描述(待实现)</label>
                    <textarea v-model="edgeForm.description" class="form-control" rows="3"></textarea>
                </div>
            </div>
            <div class="panel-actions">
                <button @click="saveEdge" class="btn btn-primary">保存(待实现)</button>
                <button @click="deleteEdge" class="btn btn-danger">删除(待实现)</button>
            </div>
        </div>

        <div v-else class="panel-content">
            <h3>属性面板</h3>
            <p class="placeholder-text">请选择一个节点或连接来查看和编辑属性</p>
        </div>
    </div>
</template>

<script>
import { ref, computed, watch } from 'vue'
import { useKnowledgeGraphStore } from '../stores/knowledgeGraphStore.js'

export default {
    name: 'PropertyPanel',
    props: {
        selectedNode: {
            type: Object,
            default: null
        },
        selectedEdge: {
            type: Object,
            default: null
        },
        groups: {
            type: Array,
            default: () => []
        }
    },
    emits: ['update-node', 'update-edge', 'delete-node', 'delete-edge', 'save-node-position'],
    setup(props, { emit }) {
        const store = useKnowledgeGraphStore()

        // 节点表单数据
        const nodeForm = ref({
            name: '',
            desc: '',
            groups: [], // 改为groups
            imageUrl: '',
            x: 0,
            y: 0,
            symbolSize: 30,
            locked: false
        })

        // 连接表单数据
        const edgeForm = ref({
            label: '',
            description: ''
        })

        // 计算属性
        const nodes = computed(() => store.nodes)
        console.log("nodes:", nodes.value)

        // 检查分组是否被选中（基于选中节点的实际分组信息）
        const isGroupSelected = (groupId) => {
            // 使用选中节点的实际分组信息（临时分组使用groups属性）
            if (props.selectedNode && props.selectedNode.groups) {
                // 确保进行严格比较，避免类型不匹配问题
                return props.selectedNode.groups.some(group => group === groupId);
            }
            return false;
        }

        // 切换分组选择（直接更新节点分组）
        const toggleGroup = (groupId) => {
            if (!props.selectedNode) return;

            // 创建当前节点分组的副本（临时分组使用groups属性）
            const currentGroups = props.selectedNode.groups ? [...props.selectedNode.groups] : [];

            const index = currentGroups.indexOf(groupId);
            if (index > -1) {
                // 如果已选中，则移除
                currentGroups.splice(index, 1);
            } else {
                // 如果未选中，则添加
                currentGroups.push(groupId);
            }
            console.log("Current Groups:", currentGroups)

            // 直接更新节点分组，不等待保存按钮（使用groups属性）
            emit('update-node', props.selectedNode.id, { groups: currentGroups });
        }

        // 获取节点标签
        const getNodeLabel = (nodeId) => {
            console.log("getNodeLabel NodeId:", nodeId)
            // const node = nodes.value.find(n => n.id === nodeId)
            // console.log("getNodeLabel Node:", node)
            // return node ? node.name : nodeId
            return nodeId.name
        }

        // 保存节点
        const saveNode = () => {
            if (props.selectedNode) {
                emit('update-node', props.selectedNode.id, {
                    name: nodeForm.value.name,
                    desc: nodeForm.value.desc,
                    groups: nodeForm.value.groups, // 使用groups
                    imageUrl: nodeForm.value.imageUrl,
                    symbolSize: nodeForm.value.symbolSize,
                    locked: nodeForm.value.locked,
                })
            }
        }

        // 保存节点位置
        const saveNodePosition = () => {
            if (props.selectedNode) {
                emit('save-node-position', props.selectedNode.id, {
                    x: nodeForm.value.x,
                    y: nodeForm.value.y
                })
            }
        }

        // 锁定节点
        const lockNode = () => {
            if (props.selectedNode) {
                emit('update-node', props.selectedNode.id, { locked: true })
            }
        }

        // 高亮节点
        const highlightNode = () => {
            if (props.selectedNode) {
                // 这里可以触发高亮事件
                console.log('高亮节点:', props.selectedNode.id)
            }
        }

        // 删除节点
        const deleteNode = () => {
            if (props.selectedNode) {
                emit('delete-node', props.selectedNode.id)
            }
        }

        // 保存连接
        const saveEdge = () => {
            if (props.selectedEdge) {
                emit('update-edge', props.selectedEdge.id, { ...edgeForm.value })
            }
        }

        // 删除连接
        const deleteEdge = () => {
            if (props.selectedEdge) {
                emit('delete-edge', props.selectedEdge.id)
            }
        }

        // 监听选中节点变化
        watch(
            () => props.selectedNode,
            (newNode) => {
                if (newNode) {
                    nodeForm.value = {
                        name: newNode.name || '',
                        desc: newNode.desc || '',
                        groups: newNode.groups || [], // 改为groups
                        imageUrl: newNode.imageUrl || '',
                        x: newNode.x || 0,
                        y: newNode.y || 0,
                        symbolSize: newNode.symbolSize || 30,
                        locked: newNode.locked || false
                    }
                }
            },
            { immediate: true }
        )

        // 监听选中连接变化
        watch(
            () => props.selectedEdge,
            (newEdge) => {
                if (newEdge) {
                    edgeForm.value = {
                        label: newEdge.label || '',
                        description: newEdge.description || ''
                    }
                }
            },
            { immediate: true }
        )

        return {
            nodeForm,
            edgeForm,
            getNodeLabel,
            isGroupSelected,
            toggleGroup,
            saveNode,
            saveNodePosition,
            lockNode,
            highlightNode,
            deleteNode,
            saveEdge,
            deleteEdge
            // 注意：不要重新导出 props，因为它们已经在 setup 函数的参数中了
            // 这样会导致 vue/no-dupe-keys 错误
        }
    }
}
</script>

<style scoped>
.property-panel {
    padding: 20px;
    height: 90%;
    overflow-y: auto;
}

.panel-content h3 {
    margin-top: 0;
    margin-bottom: 20px;
    color: #333;
    font-size: 18px;
}

.property-section {
    margin-bottom: 20px;
}

.form-group {
    margin-bottom: 15px;
}

.form-group label {
    display: block;
    margin-bottom: 5px;
    font-weight: 500;
    color: #555;
}

.form-control {
    width: 90%;
    padding: 8px 12px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    transition: border-color 0.2s;
}

.form-control:focus {
    outline: none;
    border-color: #007bff;
    box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.form-control[readonly] {
    background-color: #f8f9fa;
    cursor: not-allowed;
}

.position-inputs {
    display: flex;
    gap: 10px;
}

.position-inputs .form-control {
    flex: 1;
}

.checkbox-group label {
    display: flex;
    align-items: center;
    font-weight: normal;
    cursor: pointer;
}

.checkbox-group input[type="checkbox"] {
    margin-right: 8px;
}

.panel-actions {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    margin-top: 20px;
}

.btn {
    padding: 8px 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s;
    text-align: center;
}

.btn-primary {
    background: #007bff;
    color: white;
}

.btn-primary:hover {
    background: #0056b3;
}

.btn-secondary {
    background: #6c757d;
    color: white;
}

.btn-secondary:hover {
    background: #545b62;
}

.btn-warning {
    background: #ffc107;
    color: #212529;
}

.btn-warning:hover {
    background: #e0a800;
}

.btn-info {
    background: #17a2b8;
    color: white;
}

.btn-info:hover {
    background: #138496;
}

.btn-danger {
    background: #dc3545;
    color: white;
}

.btn-danger:hover {
    background: #c82333;
}

.placeholder-text {
    color: #6c757d;
    font-style: italic;
    text-align: center;
    margin-top: 40px;
}

/* 分组容器样式 */
.groups-container {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    background-color: #f8f9fa;
    min-height: 40px;
}

/* 分组项样式 */
.group-item {
    padding: 6px 12px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    background-color: #e9ecef;
    color: #495057;
    border: 1px solid #ced4da;
}

/* 选中的分组项样式 */
.group-item.group-selected {
    background-color: #007bff;
    color: #495057;
    /* 保持文字颜色不变 */
    border-color: #007bff;
    font-weight: bold;
}

.group-item:hover {
    opacity: 0.8;
}
</style>